<template>
	<div>
		<div class="pt-8 pb-24 px-4 lg:pt-16 h-full">
			<h3 class="w-full text-center text-5xl lg:text-7xl font-semibold text-primary leading-12">
				{{ $t('installation.title1') }}
			</h3>
			<h4 class="w-full text-center text-4xl lg:text-6xl font-medium text-default text-pretty leading-16">
				{{ $t('installation.title2') }}
			</h4>
		</div>
		<SectionContentContainer classes="-mt-16 pb-12 lg:pb-16">
			<template #items>
				<SectionInstallationContentItem
					v-for="(item, index) in $tm('installation.section-items')"
					:id="INSTALLATION_SECTION_ITEMS[index]?.id"
					:key="item"
					:copy="item"
					:viewbox="INSTALLATION_SECTION_ITEMS[index]?.viewbox"
					:image="INSTALLATION_SECTION_ITEMS[index]?.image"
				/>
			</template>
		</SectionContentContainer>
	</div>
</template>

<script setup lang="ts">
import { INSTALLATION_SECTION_ITEMS } from '@/constants/components/installation-sections'
</script>
